import HTMLPopup from "../views/components/HTMLPopup";
import ViewManager from "./ViewManager";
import { DefaultLayers } from "./Layers";
import PointerEvents from "../const/PointerEvents";

class HTMLPopupsManager {
    protected popups:Map<string,HTMLPopup>;
    protected container:HTMLElement;

    public init(container:HTMLElement){
        this.container = container;
    }

    public showPopup(name:string,content:string) {
        if(!this.popups){
            this.popups = new Map<string,HTMLPopup>();
        }
        if(this.popups.has(name)){
            this.closePopup(name);
        }

        let scene = ViewManager.getLayer("SplashOverlay").setScene("open");
        scene.interactive = true;
        scene.on(PointerEvents.DOWN,()=>{
            this.closePopup(name);
        })

        let popup = new HTMLPopup(content);
        this.container.appendChild(popup.content);
        this.popups.set(name,popup);
    }

    public closePopup(name:string){
        if(!this.popups){
           return;
        }
        if(this.popups.has(name)){
            this.container.removeChild(this.popups.get(name).content);
            this.popups.delete(name);
            ViewManager.getLayer("SplashOverlay").clear();

        }
    }
}

export default new HTMLPopupsManager();